import { buildCsvFromRows, escapeCsvCell } from '../../../shared/csv-core/infra/buildCsv';
import { getCustomerMovementTypeLabel } from '../../domain/customerMovementLabels';
import type { CustomerMovementRow } from '../../domain/customerTypes';

export function buildCustomerMovementHistoryCsv(params: {
  customerName: string;
  rows: CustomerMovementRow[];
  actorLabel: (userId: string | null | undefined) => string;
  formatMoney: (n: number) => string;
}): string {
  const { customerName, rows, actorLabel, formatMoney } = params;
  const header = [
    'fecha_iso',
    'tipo',
    'monto',
    'nota',
    'venta',
    'usuario_actor',
    'id_movimiento',
    'cliente',
  ];
  const dataLines = rows.map((row) => [
    escapeCsvCell(row.createdAt),
    escapeCsvCell(getCustomerMovementTypeLabel(row.type)),
    escapeCsvCell(formatMoney(row.amount)),
    escapeCsvCell(row.note ?? ''),
    // Ref amigable (#a1b2c3) como en la app — el UUID crudo no le dice nada al usuario.
    escapeCsvCell(row.saleShortId ? `#${row.saleShortId}` : (row.saleId ?? '')),
    escapeCsvCell(actorLabel(row.performedByUserId)),
    escapeCsvCell(row.id),
    escapeCsvCell(customerName),
  ]);
  return buildCsvFromRows(header, dataLines);
}
